<template>
  <div style="position: absolute;width: 100%;height: 100%" class="center">


    <div class="title-msg"><i><b> {{ titleTime }}</b></i></div>

    <div class="title">

      <div style="display: flex;">
        <div :class="item.active?'button-1 button-2 btn-active':'button-1 button-2 btn-none'" v-for="(item,index) in timeScreen" @click="shaxuanshijian(index)">
          {{ item.text }}
        </div>
      </div>

      <div style="display: flex;margin-right: 120px">
        <div :class="item.active?'button-1 button-2 btn-active':'button-1 button-2 btn-none'" v-for="(item,index) in platformScreen"
             @click="shaxuanpingtai(index)">
          {{ item.text }}
        </div>
      </div>


    </div>

    <div style="display: flex;padding: 20px">

      <div class="bonx">
        <img src="./static/plate_title_1.png" style="width: 100%">
        <div id="chartDataFirst" style="width: 100%;height: 300px">

        </div>
        <img src="./static/plate_title_2.png" style="width: 100%">
      </div>

      <div style="width: 50%;text-align: center">

        <div style="width: 80%;margin: 0 auto;height: 200px;display: flex;justify-content: space-evenly;align-items: center" class="totle">

          <div class="totle-item">
            <div class="totle-title">总成绩金额(元)</div>
            <div class="totle-box">{{ total }}</div>
          </div>
          <div class="totle-item">
            <div class="totle-title">营业中商户</div>
            <div class="totle-box">{{ allsim }}</div>
          </div>
          <div class="totle-item">

            <div class="totle-title">筹备中商户</div>
            <div class="totle-box">
              5
            </div>
          </div>

        </div>

      </div>
      <div class="bonx">

        <img src="./static/plate_title_3.png" style="width: 100%">
        <div id="chartDataSecond" style="width: 100%;height: 250px"></div>
        <div style="display: flex;justify-content: space-evenly" class="pingtai">
          <img src="./static/source_3.png">
          <img src="./static/source_2.png">
          <img src="./static/source_1.png">
        </div>
      </div>

    </div>

    <div style="display: flex;padding:0 20px">

      <div class="bonx2" style="border:solid 0px red;height: 530px;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
">
        <div style="display: flex;justify-content: space-evenly">
          <div style="color: #FFFFFF">
            单位:元
          </div>
          <div>
            <img style="width: 100px" src="./static/tag_22.png">
          </div>
          <div>
            <img style="width: 100px" src="./static/tag_11.png">
          </div>
        </div>
        <div>


          <div v-for="(item,index) in shoplist" class="fontliset">

            <div style="color: #FFFFFF;">
              <img src="./static/icon_4.png" style="width: 10px"> &nbsp;{{ item.name }}
            </div>
            <div style="display: flex;font-size: 12px;align-items: center">
              <img src="./static/tag_2.png" class="showimg" :style="'width:' +((item.shouru/max)*100)+'%'"> {{ item.shouru }}
            </div>
            <!--            <div style="display: flex;font-size: 12px;align-items: center">-->
            <!--              <img src="./static/tag_1.png" class="showimg" :style="'width:' +((item.baoguang/max)*100)+'%'">{{ item.baoguang }}-->
            <!--            </div>-->
          </div>

        </div>
      </div>
      <div style="width: 50%;text-align: center">

        <div class="map">

          <div v-for="(item,index) in maplist" class="weizhi" :style="'left: '+(item.x)+'px;top:'+(item.y)+'px'">

            <div class="biaodianimg">
              <div><img src="./static/icon_3.png"> &nbsp;&nbsp;{{ item.name }}</div>
              <div><img src="./static/icon_1.png">&nbsp;&nbsp; {{ item.shop }}</div>
              <div><img src="./static/icon_2.png">&nbsp;&nbsp; ￥{{ Number(item.money) }}</div>
            </div>
            <div style="text-align: center;  width: 140px; height: 90px; ">
              <img src="./static/point_to.png" style="height: 100%">
              <img src="./static/point_1.png" class="dongtu">
            </div>
          </div>

        </div>
      </div>
      <div class="bonx2">
        <img src="./static/plate_title_4.png" style="width: 100%">

        <div class="seg-r" style="text-align: right;color: #FFFFFF">
          单位：万元
        </div>
        <div class="charts-data charts-data-third" id="chartDataThird" style="height: 480px"></div>

      </div>
    </div>

  </div>
</template>

<script>
import u from "../../../assets/js/util"

export default {
  name: "dataindex",
  data() {
    return {
      titleTime: '',
      max: 0,
      allsim: 0,
      total: 0,

      titlePlatform: '',
      timeScreen: [
        // { days: '30', text: '近30天', time: '30' },
        {days: '7', text: '近7天', time: '7', active: false},
        {days: '1', text: '昨日', time: '1', active: false},
        {days: '0', text: '今日', time: '0', active: true},
      ],
      platformScreen: [
        {agentId: '-1', text: '所有平台', active: true},
        {agentId: '3', text: '抖音', active: false},
        {agentId: '1', text: '美团', active: false},
        {agentId: '2', text: '饿了么', active: false},
      ],
      shoplist: [],

      maplist: [],

      find: {
        start: 0,
        stop: 0,
        platform: "",
      }
    }
  },
  async mounted() {

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const timestamp = today.getTime();


    this.find = {
      start: timestamp,
      stop: timestamp + (1000 * 60 * 60 * 24),
      platform: "",
    }

    await this.getData(this.find)


    setInterval(() => {
      this.titleTime = u.formatDateTime(1)

      var st = document.getElementsByClassName("dongtu")
      for (var i = 0; i < st.length; i ++) {
        st[i].style = "transform: scale(2);transition: all 2s"
      }
    }, 1000)

    setInterval(async () => {

      var st = document.getElementsByClassName("dongtu")
      for (var i = 0; i < st.length; i ++) {
        st[i].style = "transform: scale(1)"
      }
      await this.timeout(1)
      var st = document.getElementsByClassName("dongtu")
      for (var i = 0; i < st.length; i ++) {
        st[i].style = "transform: scale(1.5);transition: all 2s"
      }
    }, 2000)


    setInterval(async () => {
      await this.getData(this.find)
      this.donghua()
    }, 5000)
  }
  , methods: {

    async shaxuanpingtai(i) {

      this.platformScreen.forEach((item) => {
        item.active = false
      })
      this.platformScreen[i].active = true
      this.find.platform = this.platformScreen[i].text == "所有平台" ? "" : this.platformScreen[i].text

      await this.getData(find)
    },
    async shaxuanshijian(i) {
      this.timeScreen.forEach((item) => {
        item.active = false
      })
      this.timeScreen[i].active = true

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const timestamp = today.getTime();

      if (i == 1) { //昨日

        this.find = {
          start: timestamp - (1000 * 60 * 60 * 24),
          stop: timestamp,
          platform: "",
        }
      }
      if (i == 0) { //7日


        this.find = {
          start: timestamp - (1000 * 60 * 60 * 24 * 7),
          stop: timestamp,
          platform: "",
        }

      }
      if (i == 2) { //7日
        this.find = {
          start: timestamp,
          stop: timestamp + (1000 * 60 * 60 * 24),
          platform: "",
        }
      }

      await this.getData(this.find)
    },
    async getData(find) {

      var info = await u.get_no("dataindex", "query", this.find)


      this.allsim = info.allsim
      this.maplist = info.maplist
      this.total = info.total
      if (!this.shoplist.length) {
        this.shoplist = info.shoplist
      }

      this.reloadshanghu(info.list)
      this.reschartDataSecond(info.platform)

      this.showdata()
      this.rechartDataThird()

      //
      // var allsim = 0
      //
      // var list = []
      // var platform = []
      //
      //
      // for (var platformKey in info.platform) {
      //   platform.push({value: info.platform[platformKey].total, name: platformKey},)
      //
      // }
      //
      // var strtindex = 0
      // for (var dianpiKey in info.dianpi) {
      //
      //   allsim += 1
      //
      //   if (allsim > 15) {
      //     strtindex = 1
      //   }
      //   if (allsim > 20) {
      //     strtindex = 2
      //   }
      //   var st = this.maplist[strtindex]
      //
      //   this.total += Number(info.dianpi[dianpiKey].total)
      //
      //   st.money = Number(st.money) + Number(info.dianpi[dianpiKey].total)
      //   st.shop += 1
      //
      //   list.push({value: info.dianpi[dianpiKey].total, name: info.dianpi[dianpiKey].name})
      //
      //
      //   this.shoplist.push(
      //     {
      //       name: info.dianpi[dianpiKey].name,
      //       shouru: info.dianpi[dianpiKey].total,
      //     }
      //   )
      //
      // }

    },
    rechartDataThird() {
      var echarts = this.$echarts
      var myChart = this.$echarts.init(document.getElementById('chartDataThird'));

      const option = {
        tooltip: {
          trigger: 'item',
        },
        grid: {
          top: 20,
          right: 10,
          bottom: 60,
          left: 60,
        },
        xAxis: {
          type: 'category',
          data: ['火锅', '中餐', '烟酒', '快餐', '水果', '烧烤', '柴火鸡'],
          axisLine: {
            lineStyle: {
              fontSize: 12,
              color: '#fff'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              fontSize: 12,
              color: '#7CC5F7'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#295C88',
              type: 'dashed',
            }
          }
        },
        series: [
          {
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {offset: 0, color: '#158DFD'},
                {offset: 1, color: '#9BC5F1'}
              ]),
              borderRadius: 10
            },
            label: {
              show: true,//顶部默认会展示y轴的值，可以设置false,不展示
              position: 'top',
              textStyle: {//数值样式
                fontSize: '12px',
                color: '#fff'
              },
              formatter: '{c}',
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: '#158DFD'},
                  {offset: 1, color: '#9BC5F1'}
                ])
              }
            },
            // barCategoryGap:'76%',
            data: [120, 200, 150, 80, 70, 110, 130],
            type: 'bar',
            barWidth: '20px',
          }
        ]
      };


      // var option = {
      //   xAxis: {
      //     type: 'category',
      //     data: ['火锅', '中餐', '烟酒', '快餐', '水果', '烧烤', '柴火鸡']
      //   },
      //   yAxis: {
      //     type: 'value'
      //   },
      //   series: [
      //     {
      //       data: [120, 200, 150, 80, 70, 110, 130],
      //       type: 'bar'
      //     }
      //   ]
      // };
      option && myChart.setOption(option);
    },
    async donghua() {

      var dlliust = document.getElementsByClassName("fontliset")
      var dom = dlliust[0]

      for (var i = 0; i < 100; i ++) {
        dom.style = `position: relative; right:${(i * 10)}px;`
        await this.timeout(1)
      }

      var one = this.shoplist[0]
      this.shoplist.splice(0, 1)
      dom.style = ``

      this.shoplist.push(one)


    },
    timeout(time) {
      return new Promise((r, e) => {
        setTimeout(() => {
          r()
        }, time)
      })
    }
    ,
    showdata() {

      var max = 0
      for (var i = 0; i < this.shoplist.length; i ++) {

        if (this.shoplist[i].shouru > max) {
          max = this.shoplist[i].shouru
        }

        // if (this.shoplist[i].baoguang > max) {
        //   max = this.shoplist[i].baoguang
        // }

      }

      this.max = max

    },

    reschartDataSecond(list) {
      console.log(list)
      var myChart = this.$echarts.init(document.getElementById('chartDataSecond'));
      var option = {
        tooltip: {
          trigger: 'item'
        },
        color: ['#0cfeff', '#ffc300', '#0192ff'],
        series: [
          {
            // name: '外卖平台销售额',
            type: 'pie',
            radius: ['60%', '75%'],
            startAngle: 180,
            label: {
              show: true,
              formatter(param) {
                return param.name + ' (' + param.percent * 2 + '%)';
              },
              textStyle: {
                color: '#fff'
              },

            },
            data: list
          }
        ]
      };
      option && myChart.setOption(option);
    },
    reloadshanghu(list) {
      var myChart = this.$echarts.init(document.getElementById('chartDataFirst'));


      const option = {
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            type: 'pie',
            radius: ['66%', '52%'],
            itemStyle: {
              borderRadius: 0,
              borderWidth: 0,
              show: true
            },
            label: {
              show: true,
              normal: {
                textStyle: {
                  color: '#fff'
                },
                formatter(param) {
                  return param.name;
                },
              }
            },
            labelLine: {
              show: true,
              // normal: {
              //     length: 40,//设置指示线的长度
              // }
            },
            data: list
          }
        ]
      };


      option && myChart.setOption(option);


    }
  }
}
</script>

<style scoped>

.weizhi {
  border: solid 0px red;
  position: absolute;
}

.fontliset {

  margin-top: 10px;
  padding-left: 10px;
  color: #FFFFFF
}

.showimg {
  height: 10px;

}

.pingtai img {
  width: 80px;
}

.bonx {
  width: 25%;
}

.bonx2 {
  width: 25%;
  height: 460px;
}

.dongtu {
  position: relative;
  right: 47px;
  bottom: 3px;
  opacity: 0.7;
}

.totle-item {
  color: #FFFFFF;
}

.totle-box {
  padding: 10px;
  font-size: 40px;
}

.totle-title {
  font-size: 22px;
}


* {
  background: rgba(0, 0, 0, 0);
  user-select: none;
}

.totle {
  background-image: url("./static/total_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

}

.biaodianimg {
  background-image: url("./static/map_border.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 140px;
  height: 90px;
  padding-top: 10px;

}

.biaodianimg div {
  display: flex;
  align-content: center;
  color: #FFFFFF;
  height: 33%;
  margin-left: 10px;

}

.biaodianimg img {
  width: 14px;
  height: 14px;
}

.map {
  margin: 0 auto;
  width: 80%;
  position: relative;
  bottom: 100px;
  z-index: 1;
  height: 560px;
  background-image: url("./static/map.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;


}

.title {
  margin-top: 30px;
  z-index: 99;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.title-msg {
  font-family: 'custom-font';
  font-size: 30px;
  font-weight: 500;
  color: #000000;
  background: linear-gradient(rgba(248, 253, 255, 1), rgba(11, 142, 182, 1));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  z-index: -1;
}

.center {
  background-size: 100% 100%;
  background-image: url("./static/most_bg.png");
  background-repeat: no-repeat;
  z-index: -9999;
}

.button-1 {
  border-radius: 8px;
  color: #FFFFFF;
  cursor: pointer;
  font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 20px;
  margin: 0;
  padding: 4px 14px;
  text-align: center;
  margin-left: 4%;
  white-space: nowrap;
}

.button-2 {
  margin-right: 4%;
}

.button-1:hover {
  background-color: #76afff;
}

.btn-active {
  background-color: #76afff;
  color: #FFFFFF;
}

.btn-none {
  background: #006CFF;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/page/module/dataIndex/dataindex.vue